const options = {
  5: "bg-yellow-800/5",
  10: "bg-yellow-800/10",
  25: "bg-yellow-800/25",
  50: "bg-yellow-800/50",
  75: "bg-yellow-800/75",
  90: "bg-yellow-800/90",
  100: "bg-yellow-800",
};

const from = {
  5: "from-yellow-800/5",
  10: "from-yellow-800/10",
  25: "from-yellow-800/25",
  50: "from-yellow-800/50",
  75: "from-yellow-800/75",
  90: "from-yellow-800/90",
  100: "from-yellow-800",
};

export default function getBackgroundYellow800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
